// @flow

import React from 'react'
// $FlowFixMe
import { Field } from 'redux-form'
import styled, { css } from 'styled-components'
import { Label, FormField } from 'src/components/Form'
import {
  renderField,
  renderPhone,
  renderSelect,
  renderNativeSelect,
  renderRawField
} from 'src/helpers/fieldRenderers'
import { required, validateDobDay, validateDobMonth, validateDobYear } from 'src/helpers/validation'
import { NATIONALITIES } from 'src/helpers/constants'
import { renderError, renderRadio } from '../../helpers/fieldRenderers'
import { normalizeSelect } from '../../helpers/normalize'

const RadioBox = styled.div`
  margin-top: 24px;
`

type Props = {
  isFull?: boolean,
  isPadded?: boolean,
  isGuarantor?: boolean,
  isPartner?: boolean
}

const StyledDetails = styled.div`
  ${(props: Props) =>
    props.isPadded &&
    css`
      padding: 0 40px;
    `};
`

type Lol = {
  name: string,
  meta: Object
}

type Lel = {
  props?: Lol
}

type DOB = {
  context?: Object,
  props?: Lol,
  ref?: Lel,
  getRenderedComponent?: Function
}

type State = {
  clickedOnOther?: boolean
}

class Details extends React.PureComponent<Props, State> {
  dob_day: ?DOB
  dob_month: ?DOB
  dob_year: ?DOB
  state = { clickedOnOther: false }
  onChange = (e: ?any, value: ?any) => {
    const clickedOnOther = value === 'other'
    this.setState({ clickedOnOther })
  }

  render() {
    const mq = window.matchMedia('(min-width: 480px)')
    const { isFull, isPadded, isGuarantor = false, isPartner = false } = this.props
    const clearInput = (ref: ?DOB) => {
      const rendered = ref && ref.getRenderedComponent && ref.getRenderedComponent()
      if (
        ref &&
        ref.ref &&
        ref.ref.props &&
        ref.ref.props.meta &&
        ref.ref.props.meta.error &&
        ref.context &&
        rendered &&
        rendered.props &&
        rendered.props.meta &&
        rendered.props.meta.error
      ) {
        ref.context._reduxForm.dispatch(ref.context._reduxForm.change(ref.ref.props.name, ''))
      }
    }

    const checkAndMove = (e, ref: ?DOB) => {
      if (e && ref && ref.props) {
        const { value } = e.target
        if (
          ref.props.name === 'dob_day' &&
          value.length >= 2 &&
          this.dob_month &&
          this.dob_month.getRenderedComponent
        ) {
          this.dob_month.getRenderedComponent().focusInput()
        }

        if (
          ref.props.name === 'dob_month' &&
          value.length >= 2 &&
          this.dob_year &&
          this.dob_year.getRenderedComponent
        ) {
          this.dob_year.getRenderedComponent().focusInput()
        }

        if (
          ref.props.name === 'dob_year' &&
          value.length >= 4 &&
          this.dob_year &&
          this.dob_year.getRenderedComponent
        ) {
          this.dob_year.getRenderedComponent().blurInput()
        }
      }
    }

    let err = ''
    if (isGuarantor) {
      err = "guarantor's"
    }
    if (isPartner) {
      err = "partner's"
    }
    return (
      <StyledDetails isPadded={isPadded}>
        {isFull && (
          <Field
            className="field"
            name="firstName"
            type="text"
            component={renderField}
            label="First name"
            autocomplete="given-name"
            required
            validate={[required]}
          />
        )}
        {isFull && (
          <Field
            className="field"
            name="lastName"
            type="text"
            required
            component={renderField}
            label="Last name"
            autocomplete="family-name"
            validate={[required]}
          />
        )}
        {!isFull && (
          <Field
            className="field"
            name="name"
            type="text"
            altError={`${err} name`}
            required
            component={renderField}
            label="Full name"
            autocomplete="name"
            validate={[required]}
          />
        )}
        <Field
          name="email"
          type="email"
          required
          component={renderField}
          altError={`${err} email`}
          label="Email"
          autocomplete="email"
          validate={[required]}
        />
        <Field
          name="phoneNumber"
          type="text"
          required
          component={renderPhone}
          altError={`${err} mobile number`}
          label="Mobile number"
          placeholder=""
          secondLabel="- only used in regard to your application"
          mq={mq}
          validate={[required]}
        />
        {isFull && (
          <FormField noBorder={true}>
            <Label>What is your gender?</Label>
            <RadioBox id="gender">
              <Field
                name="gender"
                component={renderRadio}
                onChange={this.onChange}
                fixedValue="female"
                label="Female"
              />
              <Field
                name="gender"
                component={renderRadio}
                onChange={this.onChange}
                fixedValue="male"
                label="Male"
              />
              <Field
                name="gender"
                component={renderRadio}
                onChange={this.onChange}
                fixedValue="other"
                label="Other"
              />
            </RadioBox>
            {this.state.clickedOnOther && (
              <Field
                className="field"
                name="gender_other"
                type="text"
                label=""
                altError="gender"
                required
                placeholder="Please specify..."
                component={renderField}
                validate={[required]}
              />
            )}
            <Field name="gender" hideArrow component={renderError} />
          </FormField>
        )}
        {isFull && (
          <FormField>
            <Label>Date of Birth</Label>
            <FormField isFlex noTopMargin>
              <Field
                name="dob_day"
                label="date of birth"
                type="number"
                component={renderRawField}
                onChange={e => checkAndMove(e, this.dob_day)}
                onFocus={() => clearInput(this.dob_day)}
                normalize={val => (`${val}`.length > 2 ? `${val}`.substring(0, 2) : val)}
                placeholder="DD"
                max="31"
                withRef
                ref={c => (this.dob_day = c)}
                validate={[required, validateDobDay]}
              />
              <Field
                name="dob_month"
                label="date of birth"
                type="number"
                max="12"
                arrowLeft="100"
                normalize={val => (`${val}`.length > 2 ? `${val}`.substring(0, 2) : val)}
                onChange={e => checkAndMove(e, this.dob_month)}
                onFocus={() => {
                  clearInput(this.dob_month)
                }}
                withRef
                ref={c => (this.dob_month = c)}
                component={renderRawField}
                placeholder="MM"
                validate={[required, validateDobMonth]}
              />
              <Field
                name="dob_year"
                label="date of birth"
                type="number"
                max="9999"
                normalize={val => (`${val}`.length > 2 ? `${val}`.substring(0, 4) : val)}
                onChange={e => checkAndMove(e, this.dob_year)}
                onFocus={() => clearInput(this.dob_year)}
                ref={c => (this.dob_year = c)}
                arrowLeft="200"
                withRef
                component={renderRawField}
                placeholder="YYYY"
                validate={[required, validateDobYear]}
              />
            </FormField>
          </FormField>
        )}
        {isFull && (
          <Field
            name="nationality"
            type="text"
            component={mq.matches ? renderSelect : renderNativeSelect}
            options={NATIONALITIES}
            normalize={normalizeSelect}
            label="Nationality"
            required
            autocomplete="nationality"
            validate={[required]}
          />
        )}
        {isFull && (
          <FormField noBorder={true}>
            <Label>Do you need a visa to stay in the UK?</Label>
            <RadioBox id="citizenship">
              <Field
                name="citizenship"
                component={renderRadio}
                fixedValue="ukOrEuCitizen"
                label="No"
              />
              <Field
                name="citizenship"
                component={renderRadio}
                fixedValue="international"
                label="Yes"
              />
            </RadioBox>
            <Field name="citizenship" hideArrow component={renderError} />
          </FormField>
        )}
      </StyledDetails>
    )
  }
}

export default Details



// WEBPACK FOOTER //
// ./src/components/Form/Details.js